@if (!loading) {
  <p-tree
    styleClass="w-full !p-0"
    loadingMode="icon"
    selectionMode="single"
    [value]="files"
    [contextMenu]="cm"
    [(selection)]="selected"
    (onNodeContextMenuSelect)="onNodeContextMenuSelect($event)"
    (onNodeExpand)="onNodeExpand($event)"
    (onNodeDoubleClick)="onNodeDoubleClick($event)"
  >
  </p-tree>
}
<p-contextMenu #cm [model]="menuItems" appendTo="body">
  <ng-template #item let-item>
    <a pRipple class="flex items-center p-contextmenu-item-link">
      <span [class]="item.icon"></span>
      <span class="ml-2">{{ item.label | translate }}</span>
    </a>
  </ng-template>
</p-contextMenu>
<input class="hidden" type="file" #elFile [(ngModel)]="file" (change)="onChooseFile($event)"/>
<p-dialog [header]="selected?.label" [modal]="true" [(visible)]="visible" [style]="{ width: '75vw', height: '85vh' }"
          [dismissableMask]="true"
          [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">
  <ng-container *ngIf="selected?.data?.urlPreview">
    <!-- Preview ảnh -->
    <img *ngIf="isImage(selected?.data?.urlPreview)" [src]="selected?.data?.urlPreview" alt="Ảnh"
         style="max-width: 100%; max-height: 100%; margin: auto"/>

    <!-- Preview PDF -->
    <iframe
      *ngIf="isPdf(selected?.data?.urlPreview)"
      [src]="selected?.data?.safeUrlPreview"
      width="100%"
      height="100%"
      style="border: none;"
    ></iframe>

    <!-- Preview Video -->
    <video
      *ngIf="isVideo(selected?.data?.urlPreview)"
      [src]="selected?.data?.urlPreview"
      width="100%"
      height="auto"
      style="max-width: 100%; max-height: 100%;"
      controls
    ></video>

    <!-- Preview Audio -->
    <audio
      *ngIf="isAudio(selected?.data?.fileName)"
      [src]="selected?.data?.urlPreview"
      style="width: 100%; margin-top: 1rem;"
      controls
    ></audio>
  </ng-container>
</p-dialog>


